import { z } from "zod";

export const GovernedCapabilitySurfaceSchema = z.enum(["public_api", "assistant"]);
export const GOVERNED_CAPABILITY_SURFACES = GovernedCapabilitySurfaceSchema.options;
export type GovernedCapabilitySurface = z.infer<typeof GovernedCapabilitySurfaceSchema>;

export const isAssistantGovernedCapabilitySurface = (surface: GovernedCapabilitySurface): boolean => {
  switch (surface) {
    case "assistant":
      return true;
    case "public_api":
      return false;
    default: {
      const unhandledSurface: never = surface;
      throw new Error(`Unhandled governed capability surface: ${unhandledSurface}`);
    }
  }
};
